import React, { useMemo, useCallback } from 'react'
import styled from '@emotion/styled'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Tabs, Typography, TabsProps } from 'antd'

const { Title } = Typography

export const PlanAndPaymentLayout: React.FC = () => {
	const location = useLocation()
	const navigate = useNavigate()

	const currentTabKey = useMemo(() => {
		const { pathname } = location

		if (pathname.endsWith('plan')) {
			return 'plan'
		}
		if (pathname.endsWith('info')) {
			return 'paymentInfo'
		}
		return 'unknown'
	}, [location])

	const onTabChanged = useCallback(
		(activeKey: string) => {
			let to: string

			if (activeKey === 'plan') {
				to = '/payment/subscribe/plan'
			} else if (activeKey === 'paymentInfo') {
				to = '/payment/subscribe/info'
			} else {
				throw new Error(`unknown active key: ${activeKey}`)
			}

			navigate(to)
		},
		[navigate],
	)

	return (
		<Container>
			<Title level={3} style={{ marginTop: '20px' }}>
				요금제 및 카드등록
			</Title>
			<Tabs items={items} activeKey={currentTabKey} onChange={onTabChanged} />
			<Outlet />
		</Container>
	)
}

const items: TabsProps['items'] = [
	{
		key: 'plan',
		label: '요금제',
	},
	{
		key: 'paymentInfo',
		label: '카드등록',
	},
]

const Container = styled.div`
	padding: 0 36px;
	max-width: 1440px;
`
